import { HttpErrorResponse, HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { from, Observable, throwError } from 'rxjs';
import { catchError, mergeMap } from 'rxjs/operators';
import { environment } from 'projects/mif-admin/environments/environment';
import { AdminAuthService } from './admin-auth.service';

@Injectable()
export class AdminAuthInterceptor implements HttpInterceptor {
  constructor(private adminAuthService: AdminAuthService) {}

  intercept(request: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
    const isApiRequest = [environment.apiBaseUrl, environment.parrotApiBaseUrl].some(
      baseUrl =>
        request.url === baseUrl || request.url.startsWith(`${baseUrl}/`) || request.url.startsWith(`${baseUrl}?`)
    );
    if (!isApiRequest) {
      return next.handle(request);
    }

    return this.adminAuthService
      .getAccessToken()
      .pipe(mergeMap(token => this.processRequestWithToken(token, request, next)));
  }

  // Checks if there is an access_token available in the authorize service
  // and adds it to the request in case it's targeted at the same origin as the
  // single page application.
  private processRequestWithToken(
    token: string | null,
    req: HttpRequest<any>,
    next: HttpHandler
  ): Observable<HttpEvent<any>> {
    if (!!token) {
      req = req.clone({
        setHeaders: {
          Authorization: `Bearer ${token}`
        }
      });
    }

    return next.handle(req).pipe(
      catchError(error => {
        if (!(error instanceof HttpErrorResponse) || error.status !== 401) {
          return throwError(() => error);
        }

        return from(this.adminAuthService.handleUnauthorized(token)).pipe(
          catchError(() => throwError(() => error)),
          mergeMap(() => throwError(() => error))
        );
      })
    );
  }
}
